import React, { useState } from "react";
import { FadeComponent } from "../fadediv/FadeComponent";
import Utils from "../../utils/Utils";
import { LoaderView } from "../loader/Loader";

export const MiscStats = ({ show = true }) => {
  const [loaderStatus, setLoaderStatus] = useState(true);

  return (
    <FadeComponent show={show}>
      <>
        <div className="Aboutside">
          <div className="container stats-explained">
            <h2 style={{ marginBottom: "30px" }}>Misc Stats</h2>

            <div className="gray-background-container" style={{ paddingTop: "30px" }}>
              <p className="misc-stats-explain-title">Spacing</p>
              <p className="text-template">
                Weighting a combination of 7 variables to quantify how much space a player or team necessitates,
                percentile (0-100). For example: Steph Curry is 1st ranking at 100, and Duncan Robinson is 2nd in the
                NBA.
              </p>
              <p className="misc-stats-explain-title">Shot Selection</p>
              <p className="text-template">
                If an average player took every shot, where your team would be in efficiency, percentile (0-100).
              </p>
              <p className="misc-stats-explain-title">Shot Making</p>
              <p className="text-template">
                How much more efficiently your team is performing compared to an average player taking each shot,
                percentile (0-100)
              </p>
              <p className="misc-stats-explain-title">Open 3 rate</p>
              <p className="text-template"> % of total 3PA's that are open 3's (0-100)</p>
              <p className="misc-stats-explain-title">Coaching ATO SQ PPP</p>
              <p className="text-template">The quality of shots (SQ PPP) a team is getting after a timeout. (0-100)</p>
              {
                // <div className="row pt-0">
                //   <div className="col-lg-12"></div>
                // </div>
              }
            </div>
          </div>
        </div>
      </>
    </FadeComponent>
  );
};
